import React, { useState } from 'react';

const Contact = () => {
    const [responseMessage, setResponseMessage] = useState('');

    // document.getElementById('loader').style.display = 'none';

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent the default form submission behavior
        const form = event.target; // Get the form element
        const formData = new FormData(form); // Collect form data

        document.getElementById('loader').style.display = 'block';

        try {
            const response = await fetch(form.action, {
                method: form.method,
                body: formData,
            });

            const text = await response.text();
            const result = JSON.parse(text);
            // console.log(response.ok);

            if (response.ok) {
                // Parse the response JSON
                // alert('hi');// Log the whole parsed response
                // console.log(response.json());
                // const result = await response.json();
            
                if (result.success) {
                    // console.log(result.success); // Should log 'true'
                    // alert('hi');
                    setResponseMessage(
                        <div style={{ color: 'green', fontWeight: 'bold', textAlign: 'center'}}>{result.message}</div>
                    );
                    document.getElementById('loader').style.display = 'none';
                    form.reset();
                } else {
                    // console.log('Error message:', result.message);
                    setResponseMessage(
                        <div style={{ color: 'red', fontWeight: 'bold', textAlign: 'center'}}>{result.message}</div>
                    );
                    document.getElementById('loader').style.display = 'none';
                }
            }
        } catch (error) {
            setResponseMessage(
                <div style={{ color: 'red', fontWeight: 'bold' }}>
                    An error occurred. Please try again later.
                </div>
            );
        }
    };

// function Contact() {
    return (
        <div>
            <div className="banner-area banner-bg-1">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="banner">
                                <h2>Contact Us</h2>
                                {/* <ul className="page-title-link">
                                    <li><a href="#">Home</a></li>
                                    <li><a href="#">Contact Us</a></li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div id="contact" className="section wb">
                <div className="container">
                    <div className="section-title text-center">
                        <h3>Get in touch</h3>
                        {/* <p className="lead">Let us give you more details about the special offer website you want us. Please fill out the form below. <br/>We have million of website owners who happy to work with us!</p> */}
                    </div>

                    <div className="row">
                        <div className="col-md-8 col-md-offset-2">
                            <div id="responseMessage">{responseMessage}</div>
                            <div className="contact_form">
                                {/* <div id="message"> */}
                                {/* <div id="responseMessage">{responseMessage}</div> */}

                                {/* <form id="contactform" className="row" action="https://mypiggycoins.com/mailer/contact.php" name="contactform" method="post" onSubmit={handleSubmit}> */}
                                <form id="contactform" className="row" action="https://mypiggycoins.com/mailer/contact.php" name="contactform" method="post" onSubmit={handleSubmit}>
                                    <fieldset className="row-fluid">
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <input type="text" name="first_name" id="first_name" className="form-control" placeholder="First Name *"/>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <input type="text" name="last_name" id="last_name" className="form-control" placeholder="Last Name (Optional)"/>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <input type="email" name="email" id="email" className="form-control" placeholder="Your Email *"/>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <input type="text" name="phone" id="phone" className="form-control" placeholder="Your Phone (Optional)"/>
                                        </div>
                                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                            <textarea className="form-control" name="comments" id="comments" rows="6" placeholder="Comment *"></textarea>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 text-center">
                                            <button type="submit" value="SEND" id="submit" className="btn btn-light btn-radius btn-brd grd1 btn-block">Submit</button>
                                        </div>
                                    </fieldset>
                                </form>
                                <div id="loader" style={{ display: 'none', position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', zIndex: '9999'}}>
                                    <div className="webloader"></div>
                                </div>
                            </div>
                        </div>
                    </div>
			
                    {/* <div className="row">
                        <div className="col-md-offset-1 col-sm-10 col-md-10 col-sm-offset-1 pd-add">
                            <div className="address-item">
                                <div className="address-icon">
                                    <i className="icon icon-location2"></i>
                                </div>
                                <h3>Headquarters</h3>
                                <p>Piggycoins Transaction Services
                                    <br/>Kharadi, Pune 4110014 MH.</p>
					        </div>
                            <div className="address-item">
                                <div className="address-icon">
                                    <i className="fa fa-envelope" aria-hidden="true"></i>
                                </div>
                                <h3>Email Us</h3>
                                <p>ma@mypiggycoins.com
                                    </p>
                            </div>
                            <div className="address-item">
                                <div className="address-icon">
                                    <i className="icon icon-headphones"></i>
                                </div>
                                <h3>Call Us</h3>
                                <p>+61 3 8376 6284
                                    </p>
                            </div>
				        </div>
			        </div> */}
			
                </div>
            </div>
        </div>
    );
};

export default Contact;